import { mapState } from 'vuex';

export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  props: ['media', 'index', 'swiper'],
  data() {
    return {
      player: null,
      isPlaying: false,
      isMuted: true,
      isIframeLoaded: false,
      activeSlideIndex: null,
      canPlay: false,
      canInteract: false,
    };
  },
  mounted() {
    this.activeSlideIndex = this.index;
  },
  computed: {
    ...mapState('product', ['activeImage', 'modal']),
  },
  methods: {
    getVimeoUrl(media) {
      return `${media.url}?autoplay=0&loop=1&muted=1&portrait=0&controls=0`;
    },
    onIframeLoaded() {
      this.isIframeLoaded = true;
      this.initVimeoPlayer();
    },
    imageLoaded() {
      if (Boolean(this.swiper)) {
        this.swiper.updateSize();
      }
    },
    initVimeoPlayer() {
      if (this.isIframeLoaded) {
        const interval = setInterval(() => {
          if (!this.$refs.vimeoPlayer) return;
          if (window.Vimeo) {
            this.player = new Vimeo.Player(this.$refs.vimeoPlayer);
            this.player.pause();
            this.isPlaying = false;

            clearInterval(interval);
          }
        }, 100);
      }
    },
    togglePlay() {
      if (this.activeSlideIndex === this.index && this.player) {
        if (!this.canInteract) {
          this.player.play().then(() => {
            this.canInteract = true;
            this.isPlaying = true;
          }).catch((error) => {
            console.error('Error playing Vimeo video:', error);
          });
        } else {
          this.player.getPaused().then((paused) => {
            if (paused) {
              this.player.play();
              this.isPlaying = true;
            } else {
              this.player.pause();
              this.isPlaying = false;
            }
          });
        }
      }
    },
    toggleMute() {
      if (this.activeSlideIndex === this.index && this.player) {
        if (!this.canInteract) {
          this.player.setMuted(true).then(() => {
            this.canInteract = true;
            this.isMuted = true;
          }).catch((error) => {
            console.error('Error muting Vimeo video:', error);
          });
        } else {
          this.player.getMuted().then((muted) => {
            if (muted) {
              this.player.setMuted(false);
              this.isMuted = false;
            } else {
              this.player.setMuted(true);
              this.isMuted = true;
            }
          });
        }
      }
    },
  },
  template: `
    <div
      class="product-gallery-mobile-slide"
      :class="{'product-gallery-mobile-slide--vimeo': media.type === 'video' && media.host === 'VIMEO'}"
      :data-thumbnail-index="index"
    >
      <vue-image
        v-if="media.type == 'image'"
        :src="media.src"
        :alt="media.alt"
        :lazy="false"
        :size="600"
        full-width="true"
        spinner="sm"
        @hook:updated="imageLoaded"
        fit="cover"
        pos="top">
      </vue-image>
      <vue-image
        v-if="media.type == 'video' && media.host === 'YOUTUBE'"
        :src="media.previewImage.src"
        :alt="media.previewImage.altText"
        :lazy="false"
        :size="600"
        full-width="true"
        spinner="sm"
        @hook:updated="imageLoaded"
        fit="cover"
        pos="top">
      </vue-image>
      <div
        class="product-gallery-mobile__vimeo"
        v-if="media.type === 'video' && media.host === 'VIMEO' && activeSlideIndex === index"
      >
        <iframe
          class="product-gallery-mobile__vimeo-iframe"
          ref="vimeoPlayer"
          :src="getVimeoUrl(media)"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          @load="onIframeLoaded"
        ></iframe>
        <button class="product-gallery-mobile__vimeo-play-pause" @click="togglePlay">
          <svg width="14" height="19" viewBox="0 0 14 19" fill="none" class="vimeo-pause" v-if="isPlaying">
            <line x1="2" y1="2" x2="2" y2="17" stroke="black" stroke-width="4" stroke-linecap="round" />
            <line x1="12" y1="2" x2="12" y2="17" stroke="black" stroke-width="4" stroke-linecap="round" />
          </svg>
          <svg width="14" height="19" viewBox="0 0 14 19" fill="none" class="vimeo-play" v-if="!isPlaying">
            <path d="M2 17L12 9.5L2 2V17Z" fill="black" />
          </svg>
        </button>
        <button class="product-gallery-mobile__vimeo-mute" @click="toggleMute">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="vimeo-mute" v-if="isMuted">
            <path d="M18.0359 9.03598L22.3916 13.5033" stroke="black" stroke-linecap="round" />
            <path d="M22.5132 9.03598L18.0862 13.4313" stroke="black" stroke-linecap="round" />
            <path d="M12 1.49998L4.97333 7.27776H0V15.2222H4.97333L12 21V1.49998Z" fill="black" />
          </svg>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="vimeo-unmute" v-if="!isMuted">
            <path d="M12 1.49998L4.97333 7.27776H0V15.2222H4.97333L12 21V1.49998Z" fill="black" />
          </svg>
        </button>  
      </div>
      <div class="product-gallery__thumbs__play-icon" role="button" tabindex=“0”>
        <svg width="52" height="36" viewBox="0 0 52 36">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-fb-play" x="0" y="0"></use>
        </svg>
      </div>
    </div>
  `,
};